import { render, staticRenderFns } from "./TableExpeditionsFee.vue?vue&type=template&id=04244770&"
import script from "./TableExpeditionsFee.vue?vue&type=script&lang=js&"
export * from "./TableExpeditionsFee.vue?vue&type=script&lang=js&"
import style0 from "./TableExpeditionsFee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports